import { Stack, Text, Title } from "@mantine/core";
import { useMemo } from "react";
import {
  DictionaryManagement,
  DictionaryService,
} from "../../components/feature-specific/DictionaryManagement";
import {
  ConsolidateEducationInstitutionsRequest,
  EducationInstitution,
  EducationInstitutionCreateRequest,
  EducationInstitutionUpdateRequest,
} from "../../models/education.model";
import { EducationDictionaryAdminService } from "../../services/admin";

export function EducationInstitutionDictionary() {
  const educationService = useMemo(
    () => new EducationDictionaryAdminService(),
    []
  );

  // Adapt EducationDictionaryAdminService to DictionaryService interface for institutions
  const dictionaryService: DictionaryService<EducationInstitution> = useMemo(
    () => ({
      getDictionary: () => educationService.getEducationInstitutions(),
      createItem: (item: Omit<EducationInstitution, "id">) =>
        educationService.createEducationInstitution({
          name: item.name,
        } as EducationInstitutionCreateRequest),
      updateItem: (id: number, item: Partial<EducationInstitution>) =>
        educationService.updateEducationInstitution(id, {
          id,
          name: item.name!,
        } as EducationInstitutionUpdateRequest),
      deleteItem: (id: number) =>
        educationService.deleteEducationInstitution(id),
      consolidateItems: (sourceId: number, targetId: number) =>
        educationService.consolidateEducationInstitutions({
          sourceInstitutionId: sourceId,
          targetInstitutionId: targetId,
        } as ConsolidateEducationInstitutionsRequest),
    }),
    [educationService]
  );

  return (
    <Stack gap="md">
      <Stack gap="xs" mb="md">
        <Title order={3} size="h4" fw={600}>
          Education Institutions
        </Title>
        <Text c="dimmed">
          Manage educational institutions like universities and colleges
        </Text>
      </Stack>

      <DictionaryManagement
        title="Education Institutions"
        service={dictionaryService}
        itemDisplayName="Institution"
        itemDisplayNamePlural="Institutions"
        canConsolidate={true}
        titleFieldName="name"
        searchPlaceholder="Search institutions..."
      />
    </Stack>
  );
}
